import { allNullCheck } from "./commonHelper";

export const getHistoryCauseText = (assessment, historyCause) => {
  if (!assessment) return "-";

  const { causeCategory, cause } = assessment;

  if (causeCategory === "unknown") return "Unknown";
  if (!allNullCheck(causeCategory) || !allNullCheck(cause)) return "-";

  if (causeCategory.toLowerCase() === "others") {
    return cause;
  }

  const category = historyCause?.find((c) => c.key === causeCategory.toLowerCase());

  if (!category) return "-";

  const option = category.options?.find((o) => o.key !== "unabletodetermine" && (o.key === cause || o.value === cause));

  if (!option) return category.value;

  return `${category.value}-${option.value}`;
};
